import toasterTypes from "@/toaster/ToasterTypes";

export default {
  namespaced: true,
  state: {
    message: "",
    type: toasterTypes.SUCCESS,
    isVisible: false,
    handler: undefined,
  },
  getters: {},
  mutations: {
    SET_MESSAGE: (state, { message, type, handler }) => {
      state.message = message;
      state.type = type;
      state.isVisible = true;
      state.handler = handler;
    },
    SET_VISIBLE: (state, isVisible) => (state.isVisible = isVisible),
  },
  actions: {},
};
